import { h, Fragment } from "preact";
import ProductOptionSwatchesGrouped from "./product-option-swatches-grouped";
import ProductOptionSwatches from "./product-option-swatches";
import ProductOptionPills from "./product-option-pills";

export default function ProductOption({
  option,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues,
  allowMaterialGroups,
  truncate,
  sizeGuide,
  swatchRequestUrl,
}) {
  const isSwatch = option.optionValues.some(
    (optionValue) => optionValue.swatch,
  );

  const showMaterialGroups =
    allowMaterialGroups &&
    option.optionValues.some((optionValue) => optionValue.materialGroup);

  const optionValues = option.optionValues;

  if (isSwatch) {
    if (showMaterialGroups) {
      return (
        <ProductOptionSwatchesGrouped
          optionValues={optionValues}
          optionName={option.optionName}
          optionLabel={option.optionLabel}
          updateOptionValue={updateOptionValue}
          selectedOptionValue={selectedOptionValue}
          disabledOptionValues={disabledOptionValues}
          truncate={truncate}
          swatchRequestUrl={swatchRequestUrl}
        />
      );
    } else {
      return (
        <ProductOptionSwatches
          optionValues={optionValues}
          optionName={option.optionName}
          optionLabel={option.optionLabel}
          updateOptionValue={updateOptionValue}
          selectedOptionValue={selectedOptionValue}
          disabledOptionValues={disabledOptionValues}
          truncate={truncate}
          swatchRequestUrl={swatchRequestUrl}
        />
      );
    }
  }

  return (
    <ProductOptionPills
      optionValues={optionValues}
      optionName={option.optionName}
      optionLabel={option.optionLabel}
      updateOptionValue={updateOptionValue}
      selectedOptionValue={selectedOptionValue}
      disabledOptionValues={disabledOptionValues}
      sizeGuide={sizeGuide}
    />
  );
}
